<template lang="pug">
#offcanvas(uk-offcanvas="esc-close: false; bg-close:false;")
  .uk-offcanvas-bar
    .map-offcanvas__contents
      //- Controllers
      vue-hazardmap-ctrl-component.hide-in-print
      //- Kmls
      vue-hazardmap-kmls-component.hide-in-print
      //- Shelters
      vue-hazardmap-shelters-component.hide-in-print
      //- ViewComponent
      vue-hazardmap-view-component
      //- Memo
      vue-hazardmap-memo-component
  
</template>

<script>
import * as types from "../js/mutations/map-mutations"
import VueHazardmapCtrlComponent from "./VueHazardmapCtrlComponent.vue"
import VueHazardmapKmlsComponent from "./VueHazardmapKmlsComponent.vue"
import VueHazardmapSheltersComponent from "./VueHazardmapSheltersComponent.vue"
import VueHazardmapViewComponent from "./VueHazardmapViewComponent.vue"
import VueHazardmapMemoComponent from "./VueHazardmapMemoComponent.vue"

export default {
  // mounted () {
  //   UIkit.offcanvas('#offcanvas').show()
  //   setTimeout(() => {
  //     UIkit.offcanvas('#offcanvas').hide()
  //   }, 1000)
  // },

  /*
    Components 
  /*---------------------------------------*/
  components: {
    VueHazardmapCtrlComponent, VueHazardmapKmlsComponent, VueHazardmapSheltersComponent,
    VueHazardmapViewComponent, VueHazardmapMemoComponent,
  },

  /*
    Watch 
  /*---------------------------------------*/
  watch: {
    offcanvas_is_show (offcanvas_is_show) {
      if (offcanvas_is_show) {
        UIkit.offcanvas('#offcanvas').show()
      } else {
        UIkit.offcanvas('#offcanvas').hide()
      }
    }
  },

  /*
    Computed 
  /*---------------------------------------*/
  computed: {
    offcanvas_is_show: {
      get () { return this.$store.getters.offcanvas_is_show},
      set (value) { this.$store.dispatch(types.TOGGLE_OFFCANVAS) }
    }
  }

}
</script>
